






































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { DataGrid, PageTitle } from '@questelservices/common-vue';
import { DxButton, DxPopup, DxProgressBar } from 'devextreme-vue';
import {
  DxColumn,
  DxFilterRow,
  DxLoadPanel,
  DxPager,
  DxPaging,
  DxRemoteOperations
} from 'devextreme-vue/data-grid';
import ClaimDialog from '@/views/activity-planner_claim-dialog.vue';
import ClaimedWork from '@/components/activity-planner/claimed-work.vue';
import ReportOnDemand from '@/components/activity-planner/report-on-demand.vue';
import AuditingBrowseModeSelectionDialog from '@/components/browse-mode/auditing-browse-mode-selection-dialog.vue';
import { MatterWorkTypeEnum } from '@/models/matter-work/MatterWorkTypeEnum';
import ClientSummary from '@/components/activity-planner/client-summary.vue';
import AnalysisTextReview from '@/components/activity-planner/analysis-text-review.vue';
import { ActivityPlannerService } from '@/service/ActivityPlannerService';
import DevExpress from 'devextreme/bundles/dx.all';
import { BatchTypeEnum } from '@/models/batch/BatchTypeEnum';

@Component({
  components: {
    AuditingBrowseModeSelectionDialog,
    ClaimDialog,
    ClaimedWork,
    ClientSummary,
    DataGrid,
    DxButton,
    DxColumn,
    DxFilterRow,
    DxLoadPanel,
    DxPager,
    DxPaging,
    DxPopup,
    DxProgressBar,
    DxRemoteOperations,
    PageTitle,
    ReportOnDemand,
    AnalysisTextReview
  }
})
export default class Auditing extends Vue {
  public $refs: Vue['$refs'] & {
    availableAuditingWorkDataGrid?: DataGrid;
    availableSavingsReportWorkDataGrid?: DataGrid;
    claimedAuditingWork?: ClaimedWork;
    clientSummaryRef?: ClientSummary;
    analysisTextReviewRef?: AnalysisTextReview;
  } = {};

  public readonly auditingWorkType: MatterWorkTypeEnum = MatterWorkTypeEnum.Auditing;
  public readonly availableAuditingWorkUrl: string = `/api/activityplanner/work/${MatterWorkTypeEnum.Auditing}`;
  public readonly browseModeDialogRef: string = 'browseModeDialogRef';
  public readonly claimDialogRef: string = 'claimDialogRef';
  public readonly clientSummaryRef: string = 'clientSummaryRef';
  public readonly reportDialogRef: string = 'reportDialogRef';  
  public readonly analysisTextReviewRef: string = 'analysisTextReviewRef';

  activityPlannerService: ActivityPlannerService;  
  productionDataStoreOptions: DevExpress.data.CustomStoreOptions;
  savingsReportStoreOptions: DevExpress.data.CustomStoreOptions;

  savingsReportTableVisible: boolean = true;

  private get browseModeDialog() {
    return this.$refs[this.browseModeDialogRef] as AuditingBrowseModeSelectionDialog;
  }

  private get claimDialog() {
    return this.$refs[this.claimDialogRef] as ClaimDialog;
  }

  private get clientSummary() {
    return this.$refs[this.clientSummaryRef] as ClientSummary;
  }

  private get reportDialog() {
    return this.$refs[this.reportDialogRef] as ReportOnDemand;
  }

  private get analysisTextReview() {
    return this.$refs[this.analysisTextReviewRef] as AnalysisTextReview;
  }

  constructor() {
    super();

    this.activityPlannerService = new ActivityPlannerService('/api');
    this.productionDataStoreOptions = {     
        load: loadOptions => 
          this.activityPlannerService
            .getAvailableWork(loadOptions, MatterWorkTypeEnum.Auditing, BatchTypeEnum.Production)        
    };

    this.savingsReportStoreOptions = {         
        load: loadOptions => 
          this.activityPlannerService
            .getAvailableWork(loadOptions, MatterWorkTypeEnum.Auditing, BatchTypeEnum.SavingsReport)     
            .then(result => {              
              let showSavingsTable = result.data.length > 0 ? true : false;
              this.updateDisplay(showSavingsTable);
              return result;
            })   
    };
  }

  updateDisplay(isVisble: boolean) {
    this.savingsReportTableVisible = isVisble;
  }

  showReportDialog() {
    this.reportDialog.show();
  }

  claimWorkRow(row: any, all: boolean, matterWorkType: MatterWorkTypeEnum) {
    this.claimDialog.clientId = row.ClientId;
    this.claimDialog.matterWorkType = matterWorkType;
    this.claimDialog.isClaimAll = all;
    this.claimDialog.show();
  }

  onDataErrorOccurred(e: any) {
    if (e != null && e.error != null) {
      e.error.message = 'Failed to load data.';
    }
  }

  refreshDataGrid() {
    if (this.$refs.availableAuditingWorkDataGrid) {
      (this.$refs.availableAuditingWorkDataGrid as any).refreshDataGrid();
    }

    if (this.$refs.availableSavingsReportWorkDataGrid) {
      (this.$refs.availableSavingsReportWorkDataGrid as any).refreshDataGrid();
    }

    if (this.$refs.claimedAuditingWork) {
      (this.$refs.claimedAuditingWork as any).refreshDataGrid();
    } 
  }

  openBrowseModeDialog() {
    this.browseModeDialog.show();
  }

  showClientSummary() {
    this.clientSummary.show();
  }

  showTextReview() {
    this.analysisTextReview.show();
  }
}
